import { PreviewOrderQueryParam } from "@saleor/createOrder/urls";
import { OrderLinesSortField } from "@saleor/graphql";
import { asSortParams } from "@saleor/utils/sort";
import { parse as parseQs } from "qs";
import React from "react";
import { RouteComponentProps } from "react-router";

import PreviewOrder from "./PreviewOrder";

const PreviewOrderView: React.FC<RouteComponentProps<any>> = ({ match }) => {
  const qs = parseQs(location.search.substr(1));
  const params: PreviewOrderQueryParam = asSortParams(
    qs,
    OrderLinesSortField,
    OrderLinesSortField.ITEM_NO
  );

  return (
    <PreviewOrder params={params} id={decodeURIComponent(match.params.id)} />
  );
};

export default PreviewOrderView;
